import axiosIns from '@/libs/axios'

const ROOT_URL = '/Admin/reports/safes'
export default {
  namespaced: true,
  state: {
    dataList: [],
    incomeDataList: [],
    grandTotal: {
      income_amount: 0,
      expense_amount: 0,
      total_amount: 0,
      carryover_amount: 0,
    },
    incomeGrandTotal: {
      receipt_amount: 0,
      non_receipt_amount: 0,
      total_amount: 0,
    },
    filterParams: {
      sdate: null,
      edate: null,
      id_bank_accounts: null,
    },
    loading: false,
  },
  getters: {
    dataList(state) {
      return state.dataList
    },
    incomeDataList(state) {
      return state.incomeDataList
    },
    grandTotal(state) {
      return state.grandTotal
    },
    incomeGrandTotal(state) {
      return state.incomeGrandTotal
    },
    filterParams(state) {
      return state.filterParams
    },
    loading(state) {
      return state.loading
    },
  },
  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = data.data
      state.grandTotal = data.grandTotal
    },
    SET_INCOME_DATA_LIST(state, data) {
      state.incomeDataList = data.data
      state.incomeGrandTotal = data.grandTotal
    },
    SET_LOADING(state, data) {
      state.loading = data
    },
  },
  actions: {
    getReport({ commit }, params) {
      commit('SET_LOADING', true)
      return axiosIns
        .post(`${ROOT_URL}`, params)
        .then(response => {
          commit('SET_DATA_LIST', response.data)
          commit('SET_LOADING', false)
          return response.data.data
        })
        .catch(error => console.error(error))
    },
    getIncomeReport({ commit }, params) {
      commit('SET_LOADING', true)
      return axiosIns
        .post(`${ROOT_URL}/incomes`, params)
        .then(response => {
          commit('SET_INCOME_DATA_LIST', response.data)
          commit('SET_LOADING', false)
          return response.data.data
        })
        .catch(error => console.error(error))
    },
  },
}
